export default "__VITE_ASSET__Dxc2BpJU__"